import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {/* omit in toc */}
    <h1 {...{
      "id": "stock-api-business-frequently-asked-questions"
    }}>{`Stock API: Business frequently asked questions`}</h1>
    <p>{`A list of questions and answers for customers and partners looking to use Stock APIs, from a business perspective. For technical questions on the Stock APIs, see the `}<a parentName="p" {...{
        "href": "/stock/docs/faq/"
      }}>{`Technical FAQ`}</a>{`.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Please note that the Stock API is only open to Stock for Enterprise customers and Adobe Affiliates at this time. See `}<a parentName="p" {...{
        "href": "./../getting-started/index.md"
      }}>{`Getting started`}</a>{` for more details. `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#general-faq"
        }}>{`General FAQ`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-the-criteria-for-applying-for-the-adobe-stock-api"
            }}>{`What are the criteria for applying for the Adobe Stock API?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-can-i-contact-adobe-stock-to-discuss-a-business-proposal-or-get-technical-assistance"
            }}>{`How can I contact Adobe Stock to discuss a business proposal or get technical assistance?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-much-does-it-cost-to-access-adobe-stock-api"
            }}>{`How much does it cost to access Adobe Stock API?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-the-api-calls-limits"
            }}>{`What are the API calls limits?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-can-i-test-the-search-api"
            }}>{`How can I test the Search API?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-can-i-test-the-licensing-api"
            }}>{`How can I test the Licensing API?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#where-i-can-find-a-technical-reference"
            }}>{`Where I can find a technical reference?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-standard-size-previews-are-available-via-the-api"
            }}>{`What standard size previews are available via the API?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-i-can-get-access-to-unwatermarked-previews-medium-or-high-resolution-size"
            }}>{`How I can get access to unwatermarked previews medium or high resolution size?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#i-am-using-fotolia-api-how-can-i-migrate-to-adobe-stock"
            }}>{`I am using Fotolia API. How can I migrate to Adobe Stock?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#are-there-any-framework-agreements-which-govern-all-adobe-stock-api-partnerships"
            }}>{`Are there any framework agreements which govern all Adobe Stock API partnerships?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#where-can-i-learn-about-the-adobe-stock-integration-with-magento"
            }}>{`Where can I learn about the Adobe Stock integration with Magento?`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#definitions-and-terms"
        }}>{`Definitions and terms`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#print-on-demand-faq"
        }}>{`Print on demand FAQ`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-the-main-objectives-of-the-print-on-demand-use-case"
            }}>{`What are the main objectives of the print on demand use case?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-type-of-assets-can-i-access-by-using-adobe-stock-api-for-print-on-demand"
            }}>{`What type of assets can I access by using Adobe Stock API for print on demand?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-online-examples-of-the-adobe-stock-api-print-on-demand-use-case"
            }}>{`What are online examples of the Adobe Stock API Print on Demand use case?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-is-the-print-on-demand-pricing-model"
            }}>{`What is the Print on demand pricing model?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#do-i-need-a-contract-to-start-my-api-print-on-demand-business"
            }}>{`Do I need a contract to start my API Print on demand business?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#is-there-any-software-with-build-in-support-or-software-developers-specialized-in-integrating-adobe-stock-api-for-print-on-demand"
            }}>{`Is there any software with build-in support or software developers specialized in integrating Adobe Stock API for Print-on-demand?`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#enterprise-faq"
        }}>{`Enterprise FAQ`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#do-i-need-to-sign-a-contract-to-build-my-enterprise-integration"
            }}>{`Do I need to sign a contract to build my Enterprise integration?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#is-there-a-separate-cost-to-use-the-stock-api"
            }}>{`Is there a separate cost to use the Stock API?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-can-i-automate-my-stock-workflows"
            }}>{`How can I automate my Stock workflows?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#may-i-use-my-creative-cloud-professional-or-professional-plus-plan-with-the-stock-api"
            }}>{`May I use my Creative Cloud Professional or Professional Plus plan with the Stock API?`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#marketing-platforms-faq"
        }}>{`Marketing Platforms FAQ`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-the-common-use-cases-of-marketing-platform-integrations"
            }}>{`What are the common use cases of Marketing Platform integrations?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-the-benefits-of-integrating-adobe-stock-into-a-marketing-platform"
            }}>{`What are the benefits of integrating Adobe Stock into a Marketing Platform?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#do-i-need-sign-a-contract-to-build-my-marketing-platform-integration"
            }}>{`Do I need sign a contract to build my marketing platform integration?`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#dams-faq"
        }}>{`DAMs FAQ`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#do-i-need-to-sign-a-contract-to-build-my-dammam-platform-integration"
            }}>{`Do I need to sign a contract to build my DAM/MAM platform integration?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#does-adobe-stock-have-a-pre-built-integration-with-the-my-dam-platform-or-can-adobe-stock-build-an-integration-with-my-platform"
            }}>{`Does Adobe Stock have a pre-built integration with the my DAM platform? (or) Can Adobe Stock build an integration with my platform?`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#affiliates-faq"
        }}>{`Affiliates FAQ`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-can-i-earn-affiliate-commissions-by-promoting-adobe-stock"
            }}>{`How can I earn affiliate commissions by promoting Adobe Stock?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#how-can-the-adobe-stock-api-help-me-earn-by-promoting-adobe-stock"
            }}>{`How can the Adobe Stock API help me earn by promoting Adobe Stock?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#what-are-benefits-of-adobe-affiliate-program"
            }}>{`What are benefits of Adobe Affiliate Program?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#are-there-any-examples-of-adobe-stock-api-affiliates-use-cases-available-online"
            }}>{`Are there any examples of Adobe Stock API Affiliates use cases available online?`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "general-faq"
    }}>{`General FAQ`}</h2>
    <h3 {...{
      "id": "what-are-the-criteria-for-applying-for-the-adobe-stock-api"
    }}>{`What are the criteria for applying for the Adobe Stock API?`}</h3>
    <p>{`Because of recent changes to our APIs, if you are not a Stock for Enterprise customer you must apply for access. Please see `}<a parentName="p" {...{
        "href": "./../getting-started/index.md"
      }}>{`Getting started`}</a>{` for more details.`}</p>
    <h3 {...{
      "id": "how-can-i-contact-adobe-stock-to-discuss-a-business-proposal-or-get-technical-assistance"
    }}>{`How can I contact Adobe Stock to discuss a business proposal or get technical assistance?`}</h3>
    <p>{`If you want to discuss a partnership with Adobe Stock please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback`}</a>{`.`}</p>
    <p>{`If you need technical help with your Stock API integration, please email `}<a parentName="p" {...{
        "href": "mailto:stockapis@adobe.com"
      }}>{`stockapis@adobe.com`}</a>{`. Please visit `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/stock/docs/"
      }}>{`https://developer.adobe.com/stock/docs/`}</a>{` for help resources, technical documentation and sample code.`}</p>
    <h3 {...{
      "id": "how-much-does-it-cost-to-access-adobe-stock-api"
    }}>{`How much does it cost to access Adobe Stock API?`}</h3>
    <p>{`Use of the Adobe Stock API is free of charge. Charges may apply when you license images via the API.`}</p>
    <h3 {...{
      "id": "what-are-the-api-calls-limits"
    }}>{`What are the API calls limits?`}</h3>
    <p>{`Currently we do not limit number of API requests, however we are monitoring usage and reserve the right to limit API calls or refuse API access for API keys which generate an unreasonable number of API calls.`}</p>
    <h3 {...{
      "id": "how-can-i-test-the-search-api"
    }}>{`How can I test the Search API?`}</h3>
    <p>{`Create an Adobe Stock API key for free at `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/console"
      }}>{`https://developer.adobe.com/console`}</a>{`.`}</p>
    <h3 {...{
      "id": "how-can-i-test-the-licensing-api"
    }}>{`How can I test the Licensing API?`}</h3>
    <p>{`Please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback from the Enterprise team`}</a>{`.`}</p>
    <h3 {...{
      "id": "where-i-can-find-a-technical-reference"
    }}>{`Where I can find a technical reference?`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/stock/docs/"
      }}>{`https://developer.adobe.com/stock/docs/`}</a></p>
    <h3 {...{
      "id": "what-standard-size-previews-are-available-via-the-api"
    }}>{`What standard size previews are available via the API?`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`110: Small (110 px)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`160: Medium (160 px)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`240: Large (240 px)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`500: Extra large (XL) (500 px). Returned with watermark. (default)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`1000: Extra-extra large (XXL) (1000 px). Returned with watermark.`}</p>
      </li>
    </ul>
    <p>{`All previews above are served from a content delivery network (CDN) for best performance.`}</p>
    <h3 {...{
      "id": "how-i-can-get-access-to-unwatermarked-previews-medium-or-high-resolution-size"
    }}>{`How I can get access to unwatermarked previews medium or high resolution size?`}</h3>
    <p>{`This requires an Adobe Stock Enterprise contract. Please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback`}</a>{` to learn more.`}</p>
    <h3 {...{
      "id": "i-am-using-fotolia-api-how-can-i-migrate-to-adobe-stock"
    }}>{`I am using Fotolia API. How can I migrate to Adobe Stock?`}</h3>
    <p>{`You can find technical resources `}<a parentName="p" {...{
        "href": "/stock/docs/faq/18-fotolia-migration-resources.md"
      }}>{`here`}</a>{`.`}</p>
    <h3 {...{
      "id": "are-there-any-framework-agreements-which-govern-all-adobe-stock-api-partnerships"
    }}>{`Are there any framework agreements which govern all Adobe Stock API partnerships?`}</h3>
    <p>{`There are two essential documents:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Adobe Developer terms `}<a parentName="p" {...{
            "href": "http://www.adobe.com/go/developer-terms"
          }}>{`http://www.adobe.com/go/developer-terms`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Adobe Stock terms: `}<a parentName="p" {...{
            "href": "http://www.adobe.com/go/stockterms"
          }}>{`http://www.adobe.com/go/stockterms`}</a></p>
      </li>
    </ul>
    <p>{`Please note that depending on your use case (see sections below), an additional contract may be required.`}</p>
    <h3 {...{
      "id": "where-can-i-learn-about-the-adobe-stock-integration-with-magento"
    }}>{`Where can I learn about the Adobe Stock integration with Magento?`}</h3>
    <p>{`Users of Magento Commerce 2.3.4 and newer have access to a pre-built integration with Adobe Stock inside the Page Builder. This allows users to search, license, and download Stock assets without leaving the Magento platform. Learn more about the `}<a parentName="p" {...{
        "href": "https://docs.magento.com/user-guide/cms/adobe-stock.html"
      }}>{`Adobe Stock Integration`}</a>{` in the Magento documentation.`}</p>
    <h2 {...{
      "id": "definitions-and-terms"
    }}>{`Definitions and terms`}</h2>
    <p>{`Here are the definitions of some standard acronyms and terms used throughout this document.`}</p>
    <p><strong parentName="p">{`POD.`}</strong>{` Print-on-Demand`}</p>
    <p><strong parentName="p">{`DAM/MAM.`}</strong>{` Digital Asset Management/Media Asset Management`}</p>
    <p><strong parentName="p">{`API.`}</strong>{` Application Programming Interface`}</p>
    <p><strong parentName="p">{`Standard content.`}</strong>{` For the purposes of this document, Standard content is a group of images (photos, vectors and illustrations) which consist of Adobe Stock's micro-stock collection. All assets in this class can be licensed for one credit with a Standard license (see below), and this license allows downloading the asset at full resolution. `}</p>
    <p><strong parentName="p">{`Standard license.`}</strong>{` This is a limited type of license offered on most Stock assets, including all Standard content (see above). With a Print on Demand contract, a Standard license may be used to print one good. This is different from Extended licenses, which may be used for unlimited prints, but at a much higher cost. For more details see `}<a parentName="p" {...{
        "href": "https://stock.adobe.com/license-terms"
      }}>{`Adobe Stock License Information`}</a>{`.`}</p>
    <p><strong parentName="p">{`Enterprise account model.`}</strong>{` Offers advanced options and volume pricing for Print-on-demand. Requires an Adobe Enterprise contract.`}</p>
    <p><strong parentName="p">{`OAuth integration.`}</strong>{` A technical workflow in which users must login to Adobe Stock to authorize their licenses.`}</p>
    <p><strong parentName="p">{`Server to Server integration`}</strong>{`. A technical workflow where the application can authenticate to Adobe Stock without any human user interaction. This method is only available for Enterprise accounts.`}</p>
    <h2 {...{
      "id": "print-on-demand-faq"
    }}>{`Print on demand FAQ`}</h2>
    <h3 {...{
      "id": "what-are-the-main-objectives-of-the-print-on-demand-use-case"
    }}>{`What are the main objectives of the print on demand use case?`}</h3>
    <p>{`You can implement the Search API and display search results from the Adobe Stock database. When your customer places an order, we require purchase of one standard license`}{`*`}{` per each produced item. For example, if you customer order 5 posters with the same image, you need acquire 5 licenses for the image.`}</p>
    <p>{`*`}{` Licenses must be from Enterprise licenses under `}<em parentName="p">{`the Enterprise account model`}</em>{`.`}</p>
    <p>{`Consumer image subscriptions (subscription plans available at: `}<a parentName="p" {...{
        "href": "https://stock.adobe.com/plans"
      }}>{`https://stock.adobe.com/plans`}</a>{` and `}<a parentName="p" {...{
        "href": "https://stock.adobe.com/teams"
      }}>{`https://stock.adobe.com/teams`}</a>{`) `}<strong parentName="p">{`cannot be used`}</strong>{` for print on demand, nor can "unlimited" Stock subscriptions included in Creative Cloud Pro/Plus agreements.`}</p>
    <h3 {...{
      "id": "what-type-of-assets-can-i-access-by-using-adobe-stock-api-for-print-on-demand"
    }}>{`What type of assets can I access by using Adobe Stock API for print on demand?`}</h3>
    <p>{`Technically, the API will give access to any kind of asset, including Premium, Video, 3D, Templates, etc.`}</p>
    <p>{`However, from a legal standpoint, Print on Demand customers may access `}<strong parentName="p">{`only Standard assets`}</strong>{` and must therefore `}<em parentName="p">{`filter out`}</em>{` Premium content and other non-Standard asset types. If you need access to other types of content in your application, please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback`}</a>{`.`}</p>
    <p>{`To filter out Premium content from Stock API search results, see the `}<a parentName="p" {...{
        "href": "/stock/docs/faq/"
      }}>{`Stock API FAQ`}</a>{`.`}</p>
    <h3 {...{
      "id": "what-are-online-examples-of-the-adobe-stock-api-print-on-demand-use-case"
    }}>{`What are online examples of the Adobe Stock API Print on Demand use case?`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nikkel-art.com"
        }}>{`https://nikkel-art.com`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.wallsauce.com/"
        }}>{`https://www.wallsauce.com/`}</a></li>
    </ul>
    <h3 {...{
      "id": "what-is-the-print-on-demand-pricing-model"
    }}>{`What is the Print on demand pricing model?`}</h3>
    <p>{`Pricing is based on volume and assumes a minimum purchase up front. Please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback`}</a>{` for pricing information.`}</p>
    <h3 {...{
      "id": "do-i-need-a-contract-to-start-my-api-print-on-demand-business"
    }}>{`Do I need a contract to start my API Print on demand business?`}</h3>
    <p>{`Yes. Please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback`}</a>{` to get a contract.`}</p>
    <h3 {...{
      "id": "is-there-any-software-with-build-in-support-or-software-developers-specialized-in-integrating-adobe-stock-api-for-print-on-demand"
    }}>{`Is there any software with build-in support or software developers specialized in integrating Adobe Stock API for Print-on-demand?`}</h3>
    <ul>
      <li parentName="ul">{`ResetPro: `}<a parentName="li" {...{
          "href": "https://reset.pro/?lang=8"
        }}>{`https://reset.pro/`}</a>{` `}
        {/*
          * Learn more at: ["How the Adobe Stock API is Helping Nikkel Art Thrive in the Print-on-Demand Industry"](https://medium.com/adobetech/how-the-adobe-stock-api-is-helping-nikkel-art-thrive-in-the-print-on-demand-industry-c4793e8cd5cd)
         */}
      </li>
      <li parentName="ul">{`Durst Smart Shop: `}<a parentName="li" {...{
          "href": "https://durst-professional-services.com/en/smart-shop"
        }}>{`https://durst-professional-services.com/en/smart-shop`}</a></li>
      <li parentName="ul">{`OnPrintShop: `}<a parentName="li" {...{
          "href": "https://www.onprintshop.com/"
        }}>{`https://www.onprintshop.com/`}</a></li>
    </ul>
    <h2 {...{
      "id": "enterprise-faq"
    }}>{`Enterprise FAQ`}</h2>
    <h3 {...{
      "id": "do-i-need-to-sign-a-contract-to-build-my-enterprise-integration"
    }}>{`Do I need to sign a contract to build my Enterprise integration?`}</h3>
    <p>{`If you are an existing Enterprise customer, typically your use of the API is included in the terms of your contract. Please contact your sales representative if you have any doubts.`}</p>
    <p>{`If you are not an Adobe Stock Enterprise customer, please `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback from the Enterprise team`}</a>{`.`}</p>
    <h3 {...{
      "id": "is-there-a-separate-cost-to-use-the-stock-api"
    }}>{`Is there a separate cost to use the Stock API?`}</h3>
    <p>{`No. Usage of the Stock API is free for all users.`}</p>
    <h3 {...{
      "id": "how-can-i-automate-my-stock-workflows"
    }}>{`How can I automate my Stock workflows?`}</h3>
    <p>{`All Adobe Enterprise customers have access to a Server to Server integration. This method uses special credentials to authorize and access its Adobe licenses which do not require a user to sign in. Subsequently, this application can perform tasks on an automated scheduled with no user interaction.`}</p>
    <p>{`Any Stock API may be used in an automated method. Examples include downloading new assets from a group’s license history, licensing assets in bulk (e.g., from a list of IDs), or integrating controls inside a corporate application which allow a non-Adobe user to download assets which have been previously licensed by a different user.`}</p>
    <h3 {...{
      "id": "may-i-use-my-creative-cloud-professional-or-professional-plus-plan-with-the-stock-api"
    }}>{`May I use my Creative Cloud Professional or Professional Plus plan with the Stock API?`}</h3>
    <p>{`Creative Cloud Professional (CC Pro) and Pro Plus plans are not designed for API use outside Adobe.  Any use of these plans through API requires Adobe business approval of the intended use case and assistance from the Stock product team.`}</p>
    <p>{`CC Pro and Pro Plus plans allow unlimited download of Adobe stock assets, without quota. For the following reasons, API access is made available only on an approved exception basis. `}</p>
    <ul>
      <li parentName="ul">{`API access may encourage “stockpiling” or bulk downloading of Adobe Stock Pro assets in violation of the governing terms of use.  `}</li>
      <li parentName="ul">{`API access may enable download of Stock assets for machine learning purposes, which is not permitted by the governing terms of use.  `}</li>
      <li parentName="ul">{`API access may encourage or enable use of Stock Pro assets in client projects as a part of agency and similar workflows.  This is not permitted by the governing terms of use.`}</li>
      <li parentName="ul">{`API access may encourage or enable use of Stock Pro assets in support of a Print on Demand (POD) business model, which is not permitted by the terms governing Adobe CC Pro and Pro Plus plans. A separate agreement with Adobe is required for such uses.`}</li>
      <li parentName="ul">{`Use of API to access Stock Pro assets may make tracking of downloaded Stock assets more difficult. Assets downloaded under CC Pro and Pro Plus plans may not be used perpetually. Once a customer’s subscription ends, the customer must cease use of previously downloaded assets in new projects. If an asset is downloaded to a Digital Asset Manager (DAM), those assets need to be removed at the end of subscription to prevent their continued use.`}</li>
    </ul>
    <p>{`For more information, please see the `}<a parentName="p" {...{
        "href": "http://www.adobe.com/go/stockterms"
      }}>{`Adobe Stock Additional Terms`}</a>{` or the PSLT that governs your use of Adobe Stock.  `}</p>
    <p>{`Despite the concerns stated above, it is technically possible to use a Server to Server integration with CC Pro plans for internal automation tasks but requires Adobe business approval of the use case and help from the Stock product team. Please contact us only if you understand the use restrictions and have a legitimate business requirement.`}</p>
    <h2 {...{
      "id": "marketing-platforms-faq"
    }}>{`Marketing Platforms FAQ`}</h2>
    <h3 {...{
      "id": "what-are-the-common-use-cases-of-marketing-platform-integrations"
    }}>{`What are the common use cases of Marketing Platform integrations?`}</h3>
    <p>{`You can integrate Adobe Stock with your e-mail platform, Content Management System (CMS), advertisement builder tool or social media marketing and management tool.`}</p>
    <h3 {...{
      "id": "what-are-the-benefits-of-integrating-adobe-stock-into-a-marketing-platform"
    }}>{`What are the benefits of integrating Adobe Stock into a Marketing Platform?`}</h3>
    <p>{`Customers can benefit from a seamless experience of searching and licensing Adobe Stock assets from within their own application.`}</p>
    <h3 {...{
      "id": "do-i-need-sign-a-contract-to-build-my-marketing-platform-integration"
    }}>{`Do I need sign a contract to build my marketing platform integration?`}</h3>
    <p>{`That depends on your desired workflow. If you want allow your customers to login to Adobe Stock by using their Adobe ID, that typically does not require a contract.`}</p>
    <p>{`If you want to use your company’s own Adobe account to license assets which may be used by your customers on your platform, please contact your Adobe account representative or `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/business/enterprise.html#creativecloud-rfi"
      }}>{`request a callback`}</a>{` to work on a contract.`}</p>
    <h2 {...{
      "id": "dams-faq"
    }}>{`DAMs FAQ`}</h2>
    <h3 {...{
      "id": "do-i-need-to-sign-a-contract-to-build-my-dammam-platform-integration"
    }}>{`Do I need to sign a contract to build my DAM/MAM platform integration?`}</h3>
    <p>{`This type of integration typically doesn’t require signing a contract. The Stock API is free and open to any developer who creates an Adobe ID (personal) account and can be used to search for Stock assets and download watermarked previews.`}</p>
    <p>{`Further, the developer can create an Adobe OAuth integration, which will allow end-users to sign in and access their own accounts. From here, they can license new assets or download previously licensed assets from their license history.`}</p>
    <p>{`If the DAM provider needs to create an integration for an Adobe Enterprise customer, some additional steps will be required. Please contact us for more information on this use case.`}</p>
    <h3 {...{
      "id": "does-adobe-stock-have-a-pre-built-integration-with-the-my-dam-platform-or-can-adobe-stock-build-an-integration-with-my-platform"
    }}>{`Does Adobe Stock have a pre-built integration with the my DAM platform? (or) Can Adobe Stock build an integration with my platform?`}</h3>
    <p>{`Adobe Stock has a pre-built integration with with the `}<a parentName="p" {...{
        "href": "https://www.adobe.com/marketing/experience-manager.html"
      }}>{`Adobe Experience Manager`}</a>{` (AEM) Assets platform. If you are an AEM user, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/experience-manager-cloud-service/content/assets/manage/aem-assets-adobe-stock"
      }}>{`more information here`}</a>{`.`}</p>
    <p>{`Adobe will be happy to work with any platform provider or customer who wishes to create a new integration, and can provide technical support, sample code and architecture guidance, but does not have the resources to perform the integration work. `}</p>
    <h2 {...{
      "id": "affiliates-faq"
    }}>{`Affiliates FAQ`}</h2>
    <h3 {...{
      "id": "how-can-i-earn-affiliate-commissions-by-promoting-adobe-stock"
    }}>{`How can I earn affiliate commissions by promoting Adobe Stock?`}</h3>
    <p>{`You can connect your API integration with `}<a parentName="p" {...{
        "href": "https://www.adobe.com/affiliates.html"
      }}>{`the Adobe Affiliate Program`}</a>{`.`}</p>
    <h3 {...{
      "id": "how-can-the-adobe-stock-api-help-me-earn-by-promoting-adobe-stock"
    }}>{`How can the Adobe Stock API help me earn by promoting Adobe Stock?`}</h3>
    <p>{`Instead of displaying static banners, text links, you can use the Adobe Stock Search API to engage your visitors, which increases the chance they purchase from stock.adobe.com. This will increase your commissions.`}</p>
    <h3 {...{
      "id": "what-are-benefits-of-adobe-affiliate-program"
    }}>{`What are benefits of Adobe Affiliate Program?`}</h3>
    <p>{`High commission: $72 when referred user subscribe to a plan with minimum 10 images a month.`}</p>
    <p>{`Cross marketing opportunity. Earn when your referred users purchase one of other Adobe products: Creative Cloud and Document Cloud.`}</p>
    {/*
     ### Are there any example scripts to get started?
     See the Medium article, “[Get Paid to Search Adobe Stock](https://medium.com/adobetech/get-paid-to-search-adobe-stock-e2ba9a7c0312).”
     */}
    <h3 {...{
      "id": "are-there-any-examples-of-adobe-stock-api-affiliates-use-cases-available-online"
    }}>{`Are there any examples of Adobe Stock API Affiliates use cases available online?`}</h3>
    <p>{`Eezy is a partner of Adobe Stock, and it has banners and custom search result widgets for Stock available on its video search pages. `}</p>
    <p>{`Example: `}<a parentName="p" {...{
        "href": "https://www.vecteezy.com/search?content_type=video&qterm=planet-saturn"
      }}>{`https://www.vecteezy.com/search?content_type=video&qterm=planet-saturn`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      